import { GenericSectionThemeType, MenuItemType } from '@utils/types'
import { IconCard } from '@components/molecules'
import { GenericSection } from '@components/organisms'
import styles from './IconsSection.module.sass'

interface Props {
  item?: MenuItemType
  className?: string
  theme?: GenericSectionThemeType
  editMode?: boolean
}

const IconsSection = (props: Props) => {
  const { item = undefined, theme = 'white', editMode = false, className = '' } = props

  return (
    <GenericSection
      item={item}
      theme={theme}
      className={`${styles.root} ${
        item?.children?.length === 7 ? styles['root--oneLine'] : ''
      } ${className}`}
    >
      {editMode ? (
        <>{item.children}</>
      ) : (
        item?.children?.length > 0 && (
          <div className={styles.list}>
            {item.children.map((i, index) => (
              <IconCard item={i} key={index} />
            ))}
          </div>
        )
      )}
    </GenericSection>
  )
}

export default IconsSection
